<template>
  <button
    type="button"
    role="switch"
    :aria-checked="modelValue"
    :disabled="Boolean(disabled)"
    class="ui-switch"
    @click="toggle"
  >
    <span class="ui-switch__track">
      <span class="ui-switch__thumb" />
    </span>
  </button>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

// defineModel в Vue 3.4+ сам управляет update:modelValue: мутация modelValue.value
// эмитит событие автоматически. Отдельный defineEmits + ручной emit создавали
// дублирующее событие (двойной v-model) и гонку listener'ов.
const modelValue = defineModel<boolean>({ required: true })

function toggle() {
  if (props.disabled) return
  modelValue.value = !modelValue.value
}
</script>

<style scoped>
.ui-switch {
  display: inline-flex;
  align-items: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
}

.ui-switch:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ui-switch__track {
  position: relative;
  width: 40px;
  height: 22px;
  background: #e2e8f0;
  border-radius: 11px;
  transition: background 0.2s ease;
}

.ui-switch[aria-checked='true'] .ui-switch__track {
  background: #0f172a;
}

.ui-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
}

.ui-switch[aria-checked='true'] .ui-switch__thumb {
  transform: translateX(18px);
}
</style>
